var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoneWhiteDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2338_6743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.01515 12.51L1.60001 11.004C1.46811 10.8648 1.36495 10.6977 1.29714 10.5135C1.22933 10.3293 1.19836 10.1321 1.20623 9.93441C1.2141 9.73674 1.26062 9.54299 1.34282 9.36559C1.42502 9.18818 1.54108 9.03103 1.68357 8.90419C3.29093 7.52526 5.17942 6.56733 7.19728 6.10736C9.05977 5.66358 10.9911 5.66223 12.8541 6.1034C14.8809 6.56351 16.7775 7.5259 18.3902 8.91259C18.5324 9.03885 18.6484 9.19528 18.7307 9.37193C18.8131 9.54857 18.8601 9.74156 18.8686 9.9386C18.8772 10.1356 18.8471 10.3324 18.7804 10.5164C18.7136 10.7004 18.6117 10.8676 18.481 11.0073L17.0677 12.5152C16.8414 12.7616 16.5386 12.9118 16.216 12.9379C15.8934 12.964 15.5729 12.8642 15.3142 12.6571C14.8017 12.2388 14.2464 11.8836 13.6589 11.5984C13.4267 11.4863 13.2295 11.3057 13.0906 11.0779C12.9518 10.85 12.8772 10.5846 12.8756 10.3129L12.8748 9.03701C11.0232 8.49579 9.06887 8.49716 7.21795 9.04097L7.21873 10.3169C7.21747 10.5885 7.14317 10.8541 7.00461 11.0821C6.86606 11.3101 6.66908 11.491 6.43699 11.6034C5.84988 11.8895 5.29503 12.2455 4.78302 12.6645C4.52185 12.8743 4.19744 12.9744 3.87148 12.946C3.54552 12.9175 3.24076 12.7623 3.01515 12.51Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2338_6743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneWhiteDown);
export default __webpack_public_path__ + "static/media/icon_phone_white_down.b635cc6fd45ce8e3f299a211b8802d5f.svg";
export { ForwardRef as ReactComponent };